import React, { useState, useEffect, useRef } from "react";
// import BASE_URL from "../../Constants/config";
import { useNavigate, useLocation } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import ViewHistoryPopup from "./view-history-popup";
import { useToast } from "../../Utils/toastContext";
import { useSelector } from "react-redux";

const ViewHistory = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [filter, setFilter] = useState(7);
  const [showRecords, setShowRecords] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterText, setFilterText] = useState("created_at");
  const location = useLocation();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [isPopupBreakdownOpen, setisPopupBreakdownOpen] = useState(false);

  const [dataTable, setDataTable] = useState([]);
  const [filteredData, setfilteredData] = useState(null);
  const [totalPages, settotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const { from } = location.state || {};
  const investment_id = useSelector((state) => state.investment.investmentId);
  const [totalCount, settotalCount] = useState(0);
  const [detailData, setDetailData] = useState([]);

  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  const getTransactionHistory = async (e) => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        `/v1/investment-portfolio/get/${investment_id}/taa-history?days=${filter}`
      );

      if (response.status == 200) {
        if (response.data.length > 0) {
          setDataTable(response.data.history);
          setCurrentPage(response.data.page);
          settotalCount(response.data.total_count);
          settotalPages(response.data.total_pages);
        } else {
          setDataTable([]);
          setCurrentPage(1);
          settotalCount(0);
          settotalPages(0);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setIsLoading(false);
    }
  };
  const filterOptions = [
    { value: 7, label: "Last 7 days" },
    { value: 30, label: "Last 30 days" },
  ];
  const handleSort = (key) => {
    setFilterText(key);
    ///getAll();
  };

  useEffect(() => {
    getTransactionHistory();
  }, [investment_id, filter]);

  const headers = [
    { label: "No", key: "created_at" },
    { label: "Date", key: "status" },
    { label: "Change done by", key: "investor_name" },
    { label: "Type of Change", key: "product_name" },
    { label: "", key: "" }, // No sorting for actions
  ];

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 7,
    label: "Last 7 days",
  });
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setFilter(selectedOption.value);
    setpreSelectedFilter(selectedOption);
  };

  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
      <div className="overflow-y-auto">
        <div className="w-full p-4 bg-white rounded-lg shadow-lg">
          <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <span className="font-medium lg:text-xl text-sm">
                Tactical Asset Allocation (TTA) - Current Target Allocation
                History
              </span>
            </div>
          </div>
          <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
            <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0"></div>

            <div className="flex items-center space-x-4">
              <Dropdown
                label=""
                options={filterOptions}
                preselectedValue={preSelectedFilter}
                onSelect={handleFilterChange}
              />
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full h-full  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
              <thead className="text-[#8C8C8C] text-left text-sm">
                <tr className="border border-[#EDEDED]">
                  {headers.map((header, index) => (
                    <th
                      key={header.label}
                      onClick={() => handleSort(header.key)}
                      className={`
                              cursor-pointer font-medium px-4 py-2 mb-5  text-left
                              ${
                                index === 0
                                  ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                                  : ""
                              }
                                  ${
                                    index === 1 ||
                                    index === 2 ||
                                    index === 3 ||
                                    index === 4 ||
                                    index === 5 ||
                                    index === 6 ||
                                    index === 7
                                      ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                      : ""
                                  }
                                ${
                                  index === 8
                                    ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                                    : ""
                                }
                            `}
                    >
                      <div class="flex items-center">
                        <span>{header.label}</span>
                        {header.label != "" && (
                          <img
                            src="/sort.svg"
                            alt="Icon"
                            class="w-4 h-4 ml-2"
                          />
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>

              {isLoading ? (
                <tbody className="shimmer-container-list ">
                  {/* Creating 5 rows of shimmer effect */}
                  {[...Array(5)].map((_, rowIndex) => (
                    <tr key={rowIndex} className="shimmer-row-list">
                      {/* Creating 7 cells in each row for shimmer */}
                      {[...Array(4)].map((_, colIndex) => (
                        <td key={colIndex} className="shimmer-cell-list">
                          <div className="shimmer-loader"></div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="text-sm font-medium text-black">
                  {dataTable.length > 0 ? (
                    dataTable.map((row, index) => (
                      <React.Fragment key={row.id}>
                        <tr
                          className={`cursor-pointer text-left mb-2 bg-[#F9F9F9]`}
                        >
                          <td className="px-4 py-2">
                            {(index + 1).toString().padStart(2, "0")}
                          </td>
                          <td className="px-4 py-2">
                            {formatDateList(row.created_at)}
                          </td>
                          <td className="px-4 py-2">{row.created_by_name}</td>
                          <td className="px-4 py-2">
                            {row.version_description}
                          </td>

                          <td
                            onClick={(e) => {
                              e.preventDefault();
                              setDetailData(row);
                              setisPopupBreakdownOpen(true);
                            }}
                            className="px-4 py-2 text-ellipsis  overflow-hidden whitespace-nowrap"
                          >
                            <span className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl">
                              View
                            </span>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center py-4" colSpan="7">
                        No results found
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
            {isPopupBreakdownOpen && (
              <ViewHistoryPopup
                detaildata={detailData}
                onClose={() => setisPopupBreakdownOpen(false)}
              />
            )}
          </div>
          {/* {isUserPopOpen && (
            <InvestorDetailPopup
              investmentID={currentInvestmentId}
              onClose={() => setisUserPopOpen(false)}
            />
          )} */}
          {!isLoading && dataTable.length > 0 && (
            <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
              <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                Showing {showRecords * (currentPage - 1) + 1} to{" "}
                {currentPage === totalPages
                  ? totalCount
                  : Math.max(showRecords * currentPage, dataTable.length)}{" "}
                of {totalCount} entries
              </div>

              <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Prev
                </button>

                {Array.from({ length: Math.min(totalPages, 5) }).map(
                  (_, index) => {
                    const startPage = Math.max(
                      1,
                      Math.min(totalPages - 4, currentPage - 2)
                    );
                    const page = startPage + index;

                    return (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`px-3 py-1 rounded ${
                          currentPage === page
                            ? "bg-black text-white"
                            : "bg-white border border-gray-300 text-black"
                        }`}
                      >
                        {page}
                      </button>
                    );
                  }
                )}

                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>{" "}
    </div>
  );
};

export default ViewHistory;
